export { initNative, identify, track, trackScreen, trackPress, stop, globalNativeClient } from "./client"
export { getActiveRouteName, trackNavigationState } from "./navigation"
export { capturePress, captureScreenView, captureScreenLeave, captureNativeError } from "./collectors"
export type { ReliaNativeOptions, NativeClient, NativePlatformInfo } from "./types"

import { initNative, identify, track, trackScreen, trackPress, stop } from "./client"
import { trackNavigationState } from "./navigation"

export const ReliaNative = {
  init: initNative,
  identify,
  track,
  trackScreen,
  trackPress,
  trackNavigationState,
  stop,
}
export default ReliaNative
